import React from "react"

export const PartsPaginationLink = ({ index, skip_parts, set_skip_parts }) => {
  const choose_parts = () => set_skip_parts(index)

  return (
    <li>
      <div
        className={`pagination-link is-clickable ${
          skip_parts === index ? "is-current" : ""
        }`}
        onClick={choose_parts}
        onKeyPress={() => {}}
        role="button"
        tabIndex="-1"
        aria-label="pagination link"
      >
        {index + 1}
      </div>
    </li>
  )
}
